import { IoIosArrowForward } from 'react-icons/io';

import { PaymentMethod } from '../../../../contracts';

import './style.scss';

interface PaymentMethodProps {
  displayName: string;
  onPaymentMethodChange: (value: PaymentMethod) => void;
  paymentMethodData: PaymentMethod;
}

export function HiddenPaymentMethod({
  displayName,
  onPaymentMethodChange,
  paymentMethodData,
}: PaymentMethodProps) {
  return (
    <div
      className={`payment-method hidden`}
      onClick={() => {
        onPaymentMethodChange(paymentMethodData);
      }}
    >
      <div>
        <img
          className="payment-method-logo"
          src={`https://media.appcharge.com/defaults/apm_logos/${paymentMethodData.paymentMethodName}_logo.png`}
          alt="payment method icon"
        />
        <h3 className="payment-method-name" title={displayName}>
          {displayName}
        </h3>
      </div>
      <IoIosArrowForward />
    </div>
  );
}
